module.exports = __webpack_public_path__ + "img/pr-2.8e29c214.png";